import { SearchQueryFilters } from "hooks/search/types";
import { isValidFilter } from "../components/filters/utils";

// Analytics-facing names; dashboards depend on these, so renames are breaking.
export const FILTER_NAME_MAP: Record<keyof SearchQueryFilters, string> = {
  keywordCount: "keyword_count",
  descriptionLength: "description_length",
  descriptionWordCount: "description_word_count",
  themaCodeCount: "thema_code_count",
  bisacCodeCount: "bisac_code_count",
  publishedAt: "publish_date",
  ageRange: "age_range",
  productGroupDescription: "book_format",
  publisher: "publisher",
  imprints: "imprint",
  author: "author",
  genre: "genre",
  keywords: "keyword",
  themaCodes: "thema_code",
  bisacCodes: "bisac_code",
  salesData: "sales_data",
};

export const getCanonicalFilterName = (key: keyof SearchQueryFilters): string =>
  FILTER_NAME_MAP[key];

export const getActiveCanonicalFilterNames = (
  filters: SearchQueryFilters,
): string[] => {
  const salesDataMaxDate = new Date();
  return (Object.keys(FILTER_NAME_MAP) as (keyof SearchQueryFilters)[])
    .filter((key) => {
      const filter = filters[key];
      return filter ? isValidFilter(filter, salesDataMaxDate) : false;
    })
    .map(getCanonicalFilterName);
};
